import { AssetType } from '../types/interfaces';

export const AssetTypeTemplate: AssetType = {
  id: 0,
  name: '',
  parameters: []
};
